import { render } from "./speakers.vue?vue&type=template&id=2f56195a&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=2f56195a&lang=scss&scoped=true"
import "./speakers.vue?vue&type=style&index=1&id=2f56195a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f56195a"

export default script